import { ApiUserMinimal } from "src/api/types";
import useApi from "src/hooks/api/utils/useApi";

type Options = {
	filter?: any;
	rememberKey?: string;
};

function useConnections(options?: Options) {
	const { state, actions, api } = useApi(
		{ id: options?.rememberKey || "CONNECTIONS" },
		{
			baseUrl: `/connections`,
			query: {
				sort: "recent",
				limit: 20,
				response_type: "option",
				with: ["forms", "values"],
				...(options?.filter || {}),
			},
		}
	);
	const connections: ApiUserMinimal[] = state?.list || [];

	const search = (search: string) => {
		actions.list({ q: search });
	};

	return {
		connections,
		connection: state?.data,
		filter: state?.filter || {},
		search: state?.filter?.q,
		status: state.status,
		pagination: state?.pagination,
		actions: {
			...actions,
			search,
		},
		api,
	};
}

export default useConnections;
